<template>
  <v-card flat border>
    <v-toolbar color="secondary" flat density="compact">
      <v-toolbar-title>
        <v-icon class="text-accent mr-4">mdi-text-box-multiple-outline</v-icon>
        <span class="text-accent text-h6 text-uppercase">{{
          $t("machines.info.order.label")
        }}</span></v-toolbar-title
      >
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" class="py-2">
          <v-text-field
            :label="$t('machines.info.order.orderNumber')"
            :model-value="machineInfo.orderNo"
            variant="underlined"
            persistent-hint
            readonly
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="py-2">
          <v-text-field
            :label="$t('machines.info.order.orderType')"
            :model-value="machineInfo.orderType"
            variant="underlined"
            persistent-hint
            readonly
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-2">
          <brk-date-picker
            :value="machineInfo.deliveryDate"
            @input="value => updateField('deliveryDate', value)"
            required
            :rules="[validationRules.required, validationRules.date]"
            :label="$t('machines.info.order.deliveryDate')"
            prepend-icon="mdi-calendar-import"
            :readonly="!isEditing"
            variant="underlined"
          ></brk-date-picker>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-2">
          <brk-date-picker
            :value="machineInfo.commissioningDate"
            @input="value => updateField('commissioningDate', value)"
            required
            :rules="[
              validationRules.required,
              validationRules.date,
              validationRules.dateInRange(
                new Date(machineInfo.commissioningDate),
                new Date(machineInfo.deliveryDate),
                maxCommissioningDate,
                $t('machines.info.validation.errors.commissioningDateInvalid')
              )
            ]"
            :label="$t('machines.info.order.commissioningDate')"
            prepend-icon="mdi-calendar-check"
            :readonly="!isEditing"
            variant="underlined"
          ></brk-date-picker>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import formatter from "@/utils/formatter"
import ValidationRules from "@/utils/validationrules"
import BrkDatePicker from "@/components/controls/BrkDatePicker.vue"
let validationRules = null

export default {
  components: {
    BrkDatePicker
  },
  props: ["machineInfo", "isEditing"],
  emits: ["update:machineInfo"],
  data: () => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return {
      validationRules: validationRules,
      today: today
    }
  },
  beforeCreate() {
    validationRules = ValidationRules()
  },
  computed: {
    maxCommissioningDate() {
      let maxDate = new Date(this.machineInfo.deliveryDate)
      maxDate.setMonth(maxDate.getMonth() + 6)
      return maxDate > this.today ? this.today : maxDate
    }
  },
  methods: {
    updateField(field, value) {
      const updatedModel = {
        ...this.machineInfo,
        [field]: value ? formatter().formatDate(value) : value
      }
      this.$emit("update:machineInfo", updatedModel)
    }
  }
}
</script>

<style></style>
